var map = {
	"./033-bm.webp": 1223,
	"./033-cn.webp": 1224,
	"./033.webp": 1225,
	"./13-bm.webp": 1226,
	"./13-cn.webp": 1227,
	"./13.webp": 1228,
	"./3-bm.webp": 1229,
	"./3-cn.webp": 1230,
	"./3.webp": 1231,
	"./angpao-bg-mobile.jpg": 1232,
	"./angpao-bg.jpg": 1233,
	"./angpao-bm.webp": 1234,
	"./angpao-cn.webp": 1235,
	"./angpao.webp": 1236,
	"./button.png": 1237,
	"./close-eye.png": 1238,
	"./coin-1.png": 1239,
	"./coin.png": 1240,
	"./ketupak-open.png": 1241,
	"./ketupak.png": 1242,
	"./ketupak_ribbon.png": 1243,
	"./rain-1.png": 1244,
	"./rain-2.png": 1245,
	"./rain-3.png": 1246,
	"./raya-bg-mobile.png": 1247,
	"./raya-bg.png": 1248,
	"./shine.png": 1249,
	"./star-1.png": 1250,
	"./star-2.png": 1251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 454;